import concreteImage from "@/assets/landing/p1.jpg";
import yardImage from "@/assets/landing/p2.jpg";
import truckImage from "@/assets/landing/p3.jpg";

const ENTRIES = [
	{
		image: concreteImage,
		alt: "Lançamento de concreto no eixo B4",
		meta: "07:40 · Estrutura / Lajes",
		title: "Lançamento de concreto no eixo B4",
		reactions: "👍 12 · 😮 11",
	},
	{
		image: truckImage,
		alt: "Conferência do slump ao lado da betoneira",
		meta: "09:20 · Estrutura / Lajes",
		title: "Conferência do slump: 10 cm, dentro do especificado",
		reactions: "👍 6",
	},
	{
		image: yardImage,
		alt: "Pátio de materiais com blocos para alvenaria",
		meta: "11:05 · Alvenaria",
		title: "Blocos do 5º pavimento recebidos e conferidos",
		reactions: "😎 3",
	},
];

export function FeedPanel() {
	return (
		<figure data-slot="panel" aria-label="Exemplo de galeria de relatos">
			<div data-slot="panel-head">
				<b data-slot="panel-title">Feed · Torre B</b>
				<span data-slot="pill">3 relatos hoje</span>
			</div>
			<ul data-slot="feed-list">
				{ENTRIES.map((entry) => (
					<li key={entry.meta} data-slot="feed-entry">
						<img src={entry.image} alt={entry.alt} width={88} height={66} />
						<div data-slot="feed-entry-body">
							<span data-slot="feed-entry-meta">{entry.meta}</span>
							<p data-slot="feed-entry-title">{entry.title}</p>
							<small data-slot="muted">{entry.reactions}</small>
						</div>
					</li>
				))}
			</ul>
		</figure>
	);
}
